<template>
    <div class="star-group" @mouseover.stop.prevent="trackMouse" @mouseout.stop.prevent="untrackMouse" @click="$emit('change', hoverRating)">
        <fa-icon v-for="index in fullStars" :key="'on'+index" :icon="['fas', 'star']" transform="shrink-1" :class="['mr-1', {'text-primary': !isHovered}]" style="width: 16.19px !important" />
        <fa-icon v-for="index in halfStars" :key="'half'+index" :icon="['fas', 'star-half-alt']" transform="shrink-1" :class="['mr-1', {'text-primary': !isHovered}]" style="width: 16.19px !important" />
        <fa-icon v-for="index in emptyStars" :key="'off'+index" :icon="['fal', 'star']" transform="shrink-1" :class="['mr-1', {'text-primary': !isHovered}]" style="width: 16.19px !important" />
    </div>
</template>

<script>
export default {
    name: 'RatingChartStars',
    model: {
        prop: 'rating',
        event: 'change',
    },
    props: {
        rating: {
            default() {
                return -1
            },
        },
        maxRating: {
            type: Number,
            default() {
                return 5
            },
        },
        editable: {
            type: Boolean,
            default() {
                return false
            }
        },
    },
    data() {
        return {
            isHovered: false,
            hoverRating_: 0,
        }
    },
    computed: {
        hoverRating: {
            get() {
                return this.constrainRange(this.hoverRating_)
            },
            set(val) {
                this.hoverRating_ = val
            },
        },
        currentRating() {
            return this.constrainRange(this.editable && this.isHovered ? this.hoverRating : this.rating)
        },
        fullStars() {
            return this.constrainRange(Math.floor(this.currentRating))
        },
        halfStars() {
            return this.constrainRange(this.maxRating - this.fullStars - this.emptyStars)
        },
        emptyStars() {
            return this.constrainRange(this.maxRating - Math.ceil(this.currentRating))
        },
    },
    methods: {
        trackMouse(e) {
            if (!this.editable) return
            
            let margin = 10
            let rect = e.target.closest('div.star-group').getBoundingClientRect();
            let x = e.clientX - rect.left;
            let width = rect.width - margin
            let rating = parseFloat(this.maxRating * x / width)
            let quantizedRating = Math.round(rating * 2, 0) / 2
            
            this.isHovered = true
            this.hoverRating = quantizedRating
        },
        untrackMouse() {
            this.isHovered = false
        },
        constrainRange(value) {
            return Math.min(Math.max(value, 0), this.maxRating)
        },
    },
};
</script>

<style lang="scss">
.rating-value {
    font-size: 9px;
    font-weight: bold;
    font-style: italic;
}
</style>